import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
              97<span className="text-accent-500">影视</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/chinese"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : isScrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电视剧..."
                className="w-48 lg:w-56 h-9 pl-9 pr-4 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isScrolled || !isHome ? 'text-foreground-700' : 'text-white'} ri-${isMobileOpen ? 'close' : 'menu'}-line`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-3">
            <Link to="/" className="block text-sm font-medium text-foreground-700 hover:text-primary-500 py-2">首页</Link>
            <Link to="/category/chinese" className="block text-sm font-medium text-foreground-700 hover:text-primary-500 py-2">分类浏览</Link>
            <Link to="/about" className="block text-sm font-medium text-foreground-700 hover:text-primary-500 py-2">关于我们</Link>
            <div className="relative pt-2">
              <input
                type="text"
                placeholder="搜索电视剧..."
                className="w-full h-9 pl-9 pr-4 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}